import { postAsync } from '../api/api';
import { MiddlewareAPI } from 'redux';
import { getTimestamp } from 'common/utils/get-timestamp';
import { TrackingImpressionRequest } from '../types';
import Cookies from 'universal-cookie';

export const buildTrackingPayload = (impressionContentId: string) => {
  const cookies = new Cookies(document.cookie);
  const sessionValue = cookies.get('rm_session') ?? '';

  return {
    link: { name: 'session', value: sessionValue },
    impressionContentId,
    timestamp: getTimestamp(),
  };
};

export const sendTrackingImpressionView = async (store: MiddlewareAPI, impressionContentId: string) => {
  await postAsync<unknown, TrackingImpressionRequest>(
    store,
    'tracking/impression/view',
    buildTrackingPayload(impressionContentId),
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );
};

export const sendTrackingImpressionClick = async (store: MiddlewareAPI, impressionContentId: string) => {
  await postAsync<unknown, TrackingImpressionRequest>(
    store,
    'tracking/impression/click',
    buildTrackingPayload(impressionContentId),
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );
};
